// extracted by mini-css-extract-plugin
export default {"wrapper":"QuotaCleanerSpacePromo__wrapper--3rfwv","button":"QuotaCleanerSpacePromo__button--1No47"};